import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
// Removed global backdrop so gradient is scoped per page (RagAgent only)

// Removed version tracking code that was causing reload issues

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
